// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wNDa6","option":"styles_option__2k3py","active":"styles_active__32OlJ"};